<template>
  <ul class="customTabs">
    <li
      v-for="item in tabs"
      :ref="item[props.value]"
      :style="{'margin': '0 ' + margin + 'px'}"
      @click="selectStatus(item)"
      :class="{ active: currentStatus == item[props.value] }"
      :key="item.value"
    >{{ item[props.label] }}</li>
    <i v-show="currentStatus!=null" class="borderBox" ref="borderBox"></i>
  </ul>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: null
    },
    defaultShow: {
      type: Boolean,
      default: true
    },
    margin: {
      type: Number,
      default: 0
    },
    props: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value'
        };
      }
    }
  },
  data() {
    return {
      currentStatus: null
    };
  },
  mounted() {
    if (this.defaultShow) {
      this.$nextTick(() => {
        this.selectStatus(this.tabs[0]);
      });
    }
  },
  methods: {
    selectStatus(item) {
      let li = this.$refs[item[this.props.value]][0];
      this.$refs['borderBox'].style.width = li.clientWidth + 'px';
      this.$refs['borderBox'].style.left = li.offsetLeft + 'px';
      // this.$refs['borderBox'].style.top = li.offsetHeight + 'px';
      this.currentStatus = item[this.props.value];
      this.$emit('change', this.currentStatus);
    }
  }
};
</script>

<style lang="scss">
.customTabs {
  position: relative;
  display: inline-flex;
  flex-wrap: wrap;
  height: 28px;
  li {
    cursor: pointer;
    line-height: 20px;
    color: #222222;
    transition: all 0.3s;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    &.active {
      font-weight: 500;
      color: #2858f8;
    }
    &:first-child {
      margin-left: 0!important;
    }
    &:nth-last-child(2) {
      margin-right: 0!important;
    }
  }
  .borderBox {
    border-radius: 2px;
    position: absolute;
    bottom: 0;
    height: 2px;
    width: 68px;
    transition: all 0.5s;
    background: #2858f8;
  }
}
</style>